import { render } from "./TeamContent.vue?vue&type=template&id=4e3adedd&ts=true"
import script from "./TeamContent.vue?vue&type=script&lang=ts"
export * from "./TeamContent.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/armieisla/workspace/charmedteq/icare/icare-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__